import { render, staticRenderFns } from "./BardToUnlayerMigrationPreview.vue?vue&type=template&id=9ac41258&scoped=true"
import script from "./BardToUnlayerMigrationPreview.vue?vue&type=script&lang=js"
export * from "./BardToUnlayerMigrationPreview.vue?vue&type=script&lang=js"
import style0 from "./BardToUnlayerMigrationPreview.vue?vue&type=style&index=0&id=9ac41258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac41258",
  null
  
)

export default component.exports